import React from 'react';
import { ChevronLeft, MapPin } from 'lucide-react';
import C from '../../constants/colors';
import CompanyMapView from './CompanyMapView';

export default function SiteScopeMapView({
  siteId, companies, sites, zones,
  employees, visitorCards, alerts, activeEvents,
  onBack, onAcknowledge,
}) {
  const site    = sites.find(s => s.id === siteId);
  const company = site ? companies.find(c => c.id === site.companyId) : null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <div style={{ padding: '12px 20px', borderBottom: `1px solid ${C.border}`, background: C.surface, flexShrink: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.textMuted, display: 'flex', alignItems: 'center', gap: '4px', padding: 0 }}>
          <ChevronLeft size={16} /><span style={{ fontSize: '13px' }}>{site?.name}</span>
        </button>
        <div style={{ width: '1px', height: '16px', background: C.border }} />
        <MapPin size={14} color={C.textSecondary} />
        <span style={{ fontSize: '12px', color: C.textMuted }}>{company?.name}</span>
        <span style={{ fontSize: '12px', color: C.textMuted }}>/</span>
        <span style={{ fontSize: '14px', fontWeight: 700, color: C.textPrimary }}>{site?.name}</span>
        <span style={{ fontSize: '12px', color: C.textMuted }}>— People Map</span>
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <CompanyMapView
          companies={company ? [company] : []}
          sites={site ? [site] : []}
          zones={zones.filter(z => z.siteId === siteId)}
          employees={employees.filter(e => e.currentSiteId === siteId)}
          visitorCards={visitorCards.filter(vc => vc.siteId === siteId)}
          alerts={alerts.filter(a => a.siteId === siteId)}
          activeEvents={activeEvents}
          onSiteClick={() => {}}
          onAcknowledge={onAcknowledge}
          initialMapFilter="total"
          siteLevel={true}
        />
      </div>
    </div>
  );
}
